import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

// confirm page of password changing
class Changepwdconfirm extends Component {
  render() {
    return (
      <div className="d-flex h-100 justify-content-center background-image">
        <div className="align-self-md-center h-auto w-40 p-4 form-container ">
          <p className="login-title">CHANGE PASSWORD</p>
          <p className='myp'>Your password has been successfully updated!</p>
          <Link
            to="/login"
            className=" btn btn-link btn-block font-weight-bold link"
          >
            CLICK HERE TO GO BACK TO LOGIN PAGE
          </Link>
        </div>
      </div>
    );
  }
}

export default Changepwdconfirm;



// WEBPACK FOOTER //
// ./src/routes/changepwdconfirm/index.js